import React, {FC} from 'react';

import {
  CallToActionTypesEnum,
  computeCallToActionFromQueryParams,
  computeInviterNameFromQueryParams,
} from './visitorCommon';
import {VisitorViewerSidebarContentRequestInvite} from './visitorViewerSidebarContentRequestInvite';
import {VisitorViewerSidebarContentTryFront} from './visitorViewerSidebarContentTryFront';

/*
 * Component.
 */

export const VisitorViewerSidebarContent: FC = () => {
  const inviterName = computeInviterNameFromQueryParams();
  const callToAction = computeCallToActionFromQueryParams();

  switch (callToAction) {
    case CallToActionTypesEnum.REQUEST_INVITE:
      return <VisitorViewerSidebarContentRequestInvite inviterName={inviterName} />;
    case CallToActionTypesEnum.TRY_FRONT:
    default:
      return <VisitorViewerSidebarContentTryFront />;
  }
};
